<!--
Vyhladavanie sa spusti 500ms po tom ako pouzivatel skonci pisanie. Je to koli tomu aby sa neserver neposielalo zbytocne vela requestov.
Je to mozne zmenit parametrom VYHLADAVANIE_DELAY

!!! POZOR kontrolka vracia cely objekt, nie len hodnotu !!!

objekt ma strukturu podla selectu:
{ 
    "ico": "00679364", 
    "dic": "1836772924", 
    "icdph": "SK2151387313", 
    "nazov": "Špeciálne systémy a software, a.s.", 
    "adresa": "Bratislava, AclaaamnmwXXX 29, 84104", 
    "forma_podn": "PO" 
  }
-->

<template>
  <v-autocomplete
    ref="control"
    v-if="l_visible"
    :errorMessages="errorMessages"
    @input="
      newVal => {
        setDirty(true);
        update(newVal);
      }
    "
    :value="ico"
    outlined
    :items="items"
    :loading="isLoading"
    hide-no-data
    :label="l_label"
    class="dynamic-input-control"
    :append-icon="isDisabled ? '' : 'mdi-chevron-down'"
    :search-input.sync="search"
    clearable
    :disabled="isDisabled"
    :rules="getRules"
    :placeholder="placeholder"
    :class="{
      validated: displayValidated && !hasError && !errorMessages,
      required: l_required,
      readonly,
    }"
    :readonly="isLoading || isDisabled"
    return-object
    :item-text="itemKey"
    item-value="ico"
  >
    <template v-slot:item="{ item }">
      <!-- template pre ico -->
      <template v-if="!obchodneMeno">
        <div class="d-flex w100">
          <v-icon class="ma-0 f18" :class="{ 'pr-5px': item.forma_podn === 'PO' }">{{
            item.forma_podn === 'PO' ? 'mdi-office-building-outline' : 'mdi-human-male'
          }}</v-icon>
          <div class="d-flex mr-25px">
          <div>
            <span
              v-for="(i, index) in generateMaskTextArray(search, item.ico)"
              :key="index"
              :class="{ 'v-list-item__mask': i.mask }"
              class="v-center-text"
            >
              {{ i.text }}
            </span>
          </div>
          </div>

          <span class="f14 pl-2px ico-item-cor v-center-text">{{ item.nazov }}</span>
          <v-icon class="ma-0 pl-25px f18">mdi-map-marker-outline</v-icon>
          <span class="f12 pl-5px v-center-text">{{ item.adresa }}</span>
        </div>
      </template>

      <!-- template pre obchodne meno -->
      <template v-else>
        <div class="d-flex w100">
          <v-icon class="f18" :class="{ 'pr-5px': item.forma_podn === 'PO' }">{{
            item.forma_podn === 'PO' ? 'mdi-office-building-outline' : 'mdi-human-male'
          }}</v-icon>
          <div class="d-flex mr-25px w250px" style="overflow: hidden">
            <div>
            <span
              v-for="(i, index) in generateMaskTextArray(search, item.nazov)"
              :key="index"
              :class="{ 'v-list-item__mask': i.mask }"
              class="v-center-text"
            >
              {{ i.text }}
            </span>
          </div>
          </div>
          <v-icon class="pl-8px f18">mdi-map-marker-outline</v-icon>
          <div class="f12 pl-5px v-center-text pr-25px">
            {{ item.adresa }}
          </div>
          <div class="v-center-text w70px ml-auto">{{ item.ico }}</div>
        </div>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import protectedAxios from '../../auth/axios.js';

import axios from 'axios';

export default {
  mixins: [dynamicControlMixin],
  props: {
    value: Object,
    formaPodn: Number, //1 - PO alebo 2 - FOP, podla toho vyhladava
    obchodneMeno: Boolean, //ak je true, tak vyhladava podla obchodneho mena
    placeholder: String,
  },
  computed: {
    itemKey() {
      return this.obchodneMeno ? 'nazov' : 'ico';
    },
  },
  watch: {
    search(val) {
      if (!this.obchodneMeno && val != null && val != '') {
        val = val?.replace(/[^\d]/g, '');
        this.search = val;
        this.$refs.control.lazySearch = val;
      }
      const currentValue = this.currentItem ? this.currentItem[this.itemKey] : null;
      if (val === currentValue) return;
      if (!val || val.length < 3) {
        this.items = [];
        return;
      }

      clearTimeout(this.loadingTimeout);

      this.loadingTimeout = setTimeout(() => this.findIco(val, false), this.VYHLADAVANIE_DELAY);
    },
    value() {
      if (!this.value) {
        this.update(null);
        return;
      }
      if (this.value.ico !== this.ico) {
        //ak ico zmeni obchodne meno, musim vyhladat obchodne meno spolu icom
        this.findIco(this.value[this.itemKey], true, this.value.ico);
      }
    },
    l_isEnabled(val) {
      this.$emit('enabledChanged', val);
    },
  },
  data() {
    return {
      data: null,
      isLoading: false,
      search: null,
      loadingTimeout: null,
      items: [],
      ico: null,
      currentItem: null,
      VYHLADAVANIE_DELAY: 500,
      isActive: null,
      obchodneMenoValue: null,
      cancelRequest: null,
    };
  },
  methods: {
    readData(config, data) {
      if (config.controlValue) {
        if (!this.obchodneMeno) this.ico = config.controlValue;
        else this.obchodneMenoValue = config.controlValue;
        return this.findIco(config.controlValue, true);
      } else this.update(null);
    },
    generateMaskTextArray(search, nazov) {
      if (!search) {
        return [
          {
            text: nazov,
            mask: false,
          },
        ];
      }

      const index = nazov.toLowerCase().indexOf(search.toLowerCase());
      const sLength = search.length;
      const nLength = nazov.length;

      //search na zaciatku
      if (index === 0) {
        return [
          {
            text: nazov.substring(0, sLength),
            mask: true,
          },
          {
            text: nazov.substring(sLength, nLength),
            mask: false,
          },
        ];
      }

      if (index + sLength === nLength) {
        //search na konci
        return [
          {
            text: nazov.substring(0, index),
            mask: false,
          },
          {
            text: nazov.substring(index, sLength),
            mask: true,
          },
        ];
      } else {
        //search medzi
        return [
          {
            text: nazov.substring(0, index),
            mask: false,
          },
          {
            text: nazov.substring(index, index + sLength),
            mask: true,
          },
          {
            text: nazov.substring(index + sLength, nLength),
            mask: false,
          },
        ];
      }
    },
    findIco(query, updateVal, zadaneIco) {
      this.isLoading = false;
      if (this.cancelRequest) {
        this.cancelRequest();
        this.cancelRequest = null;
      }
      const axiosSource = axios.CancelToken.source();
      this.cancelRequest = axiosSource.cancel;

      if (!this.formaPodn) console.warn('Kontrolka ICO musi mat zadanu formu podnikania !');

      let url = `controls/${this.obchodneMeno ? 'obchmeno' : 'ico'}?query=${encodeURIComponent(
        query
      )}&formaPodn=${this.formaPodn}`;
      //tu ide o to, aby sa obchodne meno spravne vyhladalo ak vyhladanie vyvolala kontrolka ICO
      if (
        this.obchodneMeno &&
        zadaneIco &&
        (!this.currentItem || this.currentItem.ico !== zadaneIco)
      )
        url += `&ico=${encodeURIComponent(zadaneIco)}`;

      return protectedAxios
        .get(url, { cancelToken: axiosSource.token })
        .then(res => {
          this.isLoading = false;
          this.cancelRequest = null;

          if (Array.isArray(res.data)) this.items = res.data;

          if (updateVal) this.update(this.items.find(i => i[this.itemKey] === query));
        })
        .catch(e => {
          if (!axios.isCancel(e)) {
            console.error(e);
            this.errorMessages = 'Chyba pri načítaní dát.';
            this.isLoading = false;
            this.cancelRequest = null;
          }
        });
    },
    update(newVal) {
      this.currentItem = newVal;
      this.$emit('input', newVal);
      if (
        (!this.obchodneMeno && this.ico != newVal?.ico) ||
        (this.obchodneMeno && this.obchodneMenoValue != newVal?.nazov)
      ) {
        this.ico = newVal ? newVal.ico : null;
        this.obchodneMenoValue = newVal ? newVal.nazov : null;
        const saveValue = newVal ? newVal[this.itemKey] : null;
        return this.saveValue(saveValue, true);
      }
    },
  },
  mounted() {
    if (this.ico) this.findIco(this.ico, false);
  },
};
</script>
